/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionPaymentMonthlyStatsData
 */
export interface SubscriptionPaymentMonthlyStatsData {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionPaymentMonthlyStatsData
     */
    month?: string;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPaymentMonthlyStatsData
     */
    invoicedNetAmount?: number;
}

/**
 * Check if a given object implements the SubscriptionPaymentMonthlyStatsData interface.
 */
export function instanceOfSubscriptionPaymentMonthlyStatsData(value: object): value is SubscriptionPaymentMonthlyStatsData {
    return true;
}

export function SubscriptionPaymentMonthlyStatsDataFromJSON(json: any): SubscriptionPaymentMonthlyStatsData {
    return SubscriptionPaymentMonthlyStatsDataFromJSONTyped(json, false);
}

export function SubscriptionPaymentMonthlyStatsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPaymentMonthlyStatsData {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
        'invoicedNetAmount': json['invoicedNetAmount'] == null ? undefined : json['invoicedNetAmount'],
    };
}

export function SubscriptionPaymentMonthlyStatsDataToJSON(json: any): SubscriptionPaymentMonthlyStatsData {
    return SubscriptionPaymentMonthlyStatsDataToJSONTyped(json, false);
}

export function SubscriptionPaymentMonthlyStatsDataToJSONTyped(value?: SubscriptionPaymentMonthlyStatsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
        'invoicedNetAmount': value['invoicedNetAmount'],
    };
}

